import { Route, Routes } from 'react-router-dom'
import Page from './Page'

export default function SchoolAccess() {
  return (
    <Routes>
      <Route path='/*' element={<Page />} />
      <Route path='/:id' element={<Page />} />
    </Routes>
  )
}
